/**
 * Помощник «Что хотите сделать?» на главной (components/home-assistant).
 *
 * Человек описывает задачу словами — в ответ показывается инструмент, который
 * это делает («Лучше всего подойдёт»), пара запасных и честный выход, если
 * такого инструмента нет. Ответ строит ОБЩИЙ движок (search-engine.js,
 * `TimbricaSearch.answer`).
 *
 * Скорость. Индекс каталога — 300–420 КБ, его подготовка стоит 0.35–0.6 с на
 * настольном процессоре и в разы больше на телефоне, запрос — 40–170 мс
 * (замер 23.09.2026). Поэтому:
 *   - поиск живёт в ФОНОВОМ ПОТОКЕ страницы (search-thread.js →
 *     search-worker.js, один на страницу — общий с сайдбаром и шапкой):
 *     страница не замирает ни при подготовке индекса, ни на каждом нажатии;
 *   - поток поднимается, пока главная простаивает после загрузки
 *     (requestIdleCallback), — к первому касанию индекс уже готов. На
 *     «экономии трафика» и 2G — только по первому касанию;
 *   - пример под полем отвечает МГНОВЕННО: карточка его инструмента
 *     отрисована сервером заранее, поиск только дописывает запасные.
 * Если поток не поднялся (старый браузер, запрет политики), тот же вопрос
 * решает search-thread.js в главном потоке.
 *
 * Журнал спроса. Когда ввод остановился, и когда человек что-то сделал с
 * ответом (открыл инструмент, сказал «не то», ушёл во все результаты), строка
 * уходит через общую дверь search-intent-log.js (она же у страницы /search):
 * только при согласии на аналитику, данные человека вычищает сервер.
 *
 * Плоский ES5, без сборки.
 */
(function () {
    'use strict';

    var root = document.getElementById('homeAssistant');
    if (!root) return;
    var input = document.getElementById('haInput');
    var form = root.querySelector('.ha-box');
    var goBtn = document.getElementById('haGo');
    var answer = document.getElementById('haAnswer');
    var status = document.getElementById('haStatus');
    if (!input || !form || !answer) return;

    function parse(attr) { try { return JSON.parse(root.getAttribute(attr) || '{}') || {}; } catch (e) { return {}; } }
    var S = parse('data-i18n'), G = parse('data-groups'), RT = parse('data-routes'), CHIPS = parse('data-chips');
    // Локаль страницы — от СЕРВЕРА: переводчик браузера переписывает <html lang>,
    // и iPhone с Google-переводом на tembrica.com/en искал бы «по-русски» в
    // английском индексе, а журнал записывал бы ru (30.09.2026).
    var loc = window.__LOCALE || document.documentElement.lang || 'en';
    var SEARCH_URL = root.getAttribute('data-search-url');
    var REQUEST_URL = root.getAttribute('data-request-url');
    var BROWSE_URL = root.getAttribute('data-browse-url');
    var LIMIT = 5;
    // Ответ из индекса другого языка (запрос на чужой письменности, см.
    // TimbricaSearch.otherScriptLocale) помечается названием языка на нём же —
    // самоназвание понятно тому, кто этим языком пишет, и перевода не требует.
    var LANG_NAMES = { ru: 'Русский', uk: 'Українська', ar: 'العربية', ko: '한국어',
        en: 'English', de: 'Deutsch', es: 'Español', fr: 'Français', id: 'Bahasa Indonesia', pt: 'Português' };

    function esc(s) {
        return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function slugOf(t) { return String((t && t.url) || '').split('?')[0].split('/').pop(); }
    function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
    var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
    function feature(f, v) { try { if (window.__ae) window.__ae('feature_use', { f: f, v: v }); } catch (e) {} }

    /* ── Движок: общий поток поиска страницы (search-thread.js) ─────────
       С 23.10.2026 у помощника нет своего потока: на главной их было два —
       этот и сайдбара (тот готовил индекс ещё и на главном потоке). Один поток
       на страницу — одна подготовка индекса; запасной путь (нет потоков, поток
       упал) и второй ответ из индекса чужой письменности живут там же. */
    function thread() { return window.__searchThread || null; }
    function start(why) {
        var T = thread();
        if (!T) return;
        var was = T.mode();
        var m = T.start(why);
        if (!was) feature('home_assistant_engine', m + ':' + why);
    }
    var asked = 0;              // номер последнего вопроса; clear() его тоже сдвигает
    function query(q) {
        var T = thread();
        if (!T) return;
        if (!T.mode()) start('typed');
        if (!T.ready() && answer.hidden) loadingNote();
        var my = ++asked;
        T.answer(q, function (st) {
            if (my === asked && norm(input.value) === st.q) show(st);
        }, 'ha');
    }
    function loadingNote() {
        answer.hidden = false;
        answer.innerHTML = '<p class="ha-note">' + esc(S.loading) + '</p>';
    }

    // Предзагрузка: поток и индекс готовятся, пока главная простаивает.
    // Самая посещаемая страница сайта не должна платить за это на медленной
    // связи — там поток поднимается только по первому касанию.
    function slowLink() {
        var c = navigator.connection;
        return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
    }
    function idle(fn) {
        if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 4000 });
        else setTimeout(fn, 1500);
    }
    // Не ждём `load`: его держат реклама и счётчики, и на главной он
    // приходит через секунды после того, как страница уже видна и в поле
    // можно печатать. Документ разобран — дальше решает простой браузера.
    if (!slowLink()) {
        if (document.readyState !== 'loading') idle(function () { start('idle'); });
        else document.addEventListener('DOMContentLoaded', function () { idle(function () { start('idle'); }); });
    }
    function warm() { start('touch'); }
    root.addEventListener('focusin', warm);
    root.addEventListener('pointerenter', warm);
    root.addEventListener('touchstart', warm, { passive: true });

    /* ── Состояние ответа ──────────────────────────────────────────────── */
    // Что показано сейчас. Журнал и телеметрия пишут ровно это состояние, а
    // не то, что было нажатием раньше.
    var state = null;
    var fromChip = false;

    /* ── Отрисовка ─────────────────────────────────────────────────────── */
    function hueOf(t) { var g = G[t.group]; return g ? g.h : 205; }
    function rubricOf(t) { var g = G[t.group]; return g ? g.t : ''; }

    function bestCard(t, rank, routeLabel) {
        var name = routeLabel ? routeLabel.name : t.name;
        var desc = routeLabel ? routeLabel.desc : t.desc;
        var href = routeLabel ? routeLabel.url : t.url;
        var rubric = rubricOf(t);
        return '<a class="ha-best" href="' + esc(href) + '" data-ha-rank="' + rank + '" data-ha-slug="' + esc(slugOf(t)) + '" style="--hue:' + hueOf(t) + '">'
            + '<span class="ha-ico" aria-hidden="true">' + esc(t.icon || '') + '</span>'
            + '<span class="ha-main"><span class="ha-name">' + esc(name) + '</span>'
            + (desc ? '<span class="ha-desc">' + esc(desc) + '</span>' : '')
            + (rubric ? '<span class="ha-rubric">' + esc(rubric) + '</span>' : '')
            + '</span>'
            + '<span class="ha-open">' + esc(S.open || '') + ARROW + '</span></a>';
    }
    function row(t, rank) {
        return '<a class="ha-row" href="' + esc(t.url) + '" data-ha-rank="' + rank + '" data-ha-slug="' + esc(slugOf(t)) + '" style="--hue:' + hueOf(t) + '">'
            + '<span class="ha-row-ico" aria-hidden="true">' + esc(t.icon || '') + '</span>'
            + '<span class="ha-row-txt"><span class="ha-row-name">' + esc(t.name) + '</span>'
            + (t.desc ? '<span class="ha-row-desc">' + esc(t.desc) + '</span>' : '')
            + '</span></a>';
    }
    function requestHref(q) { return REQUEST_URL + (REQUEST_URL.indexOf('?') < 0 ? '?' : '&') + 'q=' + encodeURIComponent(q); }
    function searchHref(q) { return SEARCH_URL + '?q=' + encodeURIComponent(q); }

    function render(st) {
        var html = '';
        if (st.kind === 'empty') {
            html = '<div class="ha-none"><p class="ha-none-title">' + esc(S.none_title) + '</p>'
                + '<p class="ha-none-text">' + esc(S.none_text) + '</p>'
                + '<div class="ha-none-acts"><a class="ha-btn" data-ha-act="unmet" href="' + esc(requestHref(st.q)) + '">' + esc(S.request) + '</a>'
                + '<a class="ha-link" data-ha-act="browse" href="' + esc(BROWSE_URL) + '">' + esc(S.browse) + '</a></div></div>';
        } else {
            if (st.lang) html += '<p class="ha-note" lang="' + esc(st.lang) + '">🌐 ' + esc(LANG_NAMES[st.lang] || st.lang) + '</p>';
            if (st.kind === 'partial') {
                html += '<div class="ha-partial">' + esc(S.partial)
                    + '<br><a class="ha-btn" data-ha-act="unmet" href="' + esc(requestHref(st.q)) + '">' + esc(S.request) + '</a></div>';
            } else if (st.dym) html += '<p class="ha-note">' + esc(S.did_you_mean) + ' <b>' + esc(st.dym) + '</b></p>';
            else if (st.kind === 'fuzzy') html += '<p class="ha-note">' + esc(S.did_you_mean) + '</p>';
            var list = st.list.slice(0, LIMIT), start0 = 0;
            if (st.confident && list.length) {
                html += '<p class="ha-label">' + esc(S.best) + '</p>';
                var rl = null;
                if (st.route) {
                    rl = { name: list[0].t.name + ' · ' + st.route.value, desc: RT[st.route.kind] || list[0].t.desc, url: st.route.url };
                }
                html += bestCard(list[0].t, 1, rl);
                start0 = 1;
                if (list.length > 1) html += '<p class="ha-label" style="margin-top:16px">' + esc(S.also) + '</p>';
            } else if (st.kind !== 'fuzzy' && st.kind !== 'partial' && !st.dym) {
                html += '<p class="ha-label">' + esc(S.matches) + '</p>';
            }
            if (list.length > start0) {
                html += '<div class="ha-list' + (start0 ? '' : ' ha-list-first') + '">';
                for (var i = start0; i < list.length; i++) html += row(list[i].t, i + 1);
                html += '</div>';
            }
            html += '<div class="ha-foot"><span>' + esc(S.not_it) + ' <a data-ha-act="unmet" href="' + esc(requestHref(st.q)) + '">' + esc(S.describe) + '</a></span>'
                + (st.list.length > LIMIT || st.kind === 'fuzzy'
                    ? '<a data-ha-act="more" href="' + esc(searchHref(st.q)) + '">' + esc(S.all) + '</a>' : '')
                + '</div>';
        }
        answer.innerHTML = html;
        answer.hidden = false;
        root.classList.add('ha-has-answer');
        if (status) status.textContent = st.kind === 'empty' ? S.none_title : String(S.found || '').replace(':n', String(st.list.length));
    }

    var langShown = '';
    function show(st) {
        state = st;
        if (st.lang && st.q !== langShown) { langShown = st.q; feature('search_other_lang', 'home:' + st.lang); }
        render(st);
        settle(st);
    }

    function clear() {
        answer.hidden = true;
        answer.innerHTML = '';
        root.classList.remove('ha-has-answer');
        state = null;
        asked++;                // опоздавший ответ потока не должен вернуть очищенное
        if (status) status.textContent = '';
        cancelSettle();
    }

    /* ── Журнал и телеметрия ───────────────────────────────────────────── */
    function logIntent(act, extra) {
        // Пример из подсказки — не слова человека: такой запрос в журнал
        // спроса не пишется, пока человек его не поправил.
        if (!state || fromChip || !window.__searchIntent) return;
        window.__searchIntent.log('home', act, state, extra);
    }

    var settleTimer = null;
    function cancelSettle() {
        clearTimeout(settleTimer);
        try { if (window.__aeDeferredCancel) window.__aeDeferredCancel('ha_q'); } catch (e) {}
    }
    function settle(st) {
        cancelSettle();
        var q = st.q;
        if (q.length < 3) return;
        // Та же пара событий, что у поиска в шапке, — чтобы доля промахов на
        // /pino/search-misses считалась и по главной. `src` отличает поверхность.
        try {
            if (window.__aeDeferred) {
                var src = fromChip ? 'home-chip' : 'home';
                // Промах — всё, что не прямое попадание; `r` говорит, чем его
                // спасли (роутер, раскладка, разрез), как у поиска в шапке.
                if (st.kind === 'hit') {
                    window.__aeDeferred('ha_q', 'search_query', { q: q.slice(0, 60), loc: loc, n: st.list.length, src: src }, 1200);
                } else {
                    window.__aeDeferred('ha_q', 'search_miss', { q: q.slice(0, 60), loc: loc, r: st.kind === 'empty' ? '' : (st.route ? st.route.kind : st.kind), src: src }, 1200);
                }
            }
        } catch (e) {}
        settleTimer = setTimeout(function () {
            if (state && state.q === q) logIntent('q');
        }, 1500);
    }

    /* ── Ввод ──────────────────────────────────────────────────────────── */
    function autogrow() {
        input.style.height = 'auto';
        input.style.height = Math.min(input.scrollHeight, 132) + 'px';
    }
    function syncGo() { if (goBtn) goBtn.disabled = input.value.trim().length < 2; }

    function run() {
        var q = norm(input.value);
        syncGo();
        if (q.length < 2) { clear(); return; }
        query(q);
    }

    var debounce = null;
    input.addEventListener('input', function () {
        fromChip = false;
        autogrow();
        clearTimeout(debounce);
        // В потоке запрос не мешает отрисовке — ждать почти нечего; в
        // главном потоке пауза чуть длиннее, чтобы не считать каждую букву.
        debounce = setTimeout(run, (thread() && thread().mode() === 'worker') ? 40 : 90);
    });

    function openBest() {
        var a = answer.querySelector('.ha-best');
        if (a) { a.click(); return true; }
        return false;
    }
    function submit() {
        var q = norm(input.value);
        if (q.length < 2) return;
        // Ответ уже на экране и в нём есть явный лучший — Enter его и
        // открывает, как в Spotlight. Иначе — все результаты на /search.
        if (state && state.q === q && state.confident && openBest()) return;
        if (state && state.q === q) logIntent('more');
        window.location.href = searchHref(q);
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    function links() { return Array.prototype.slice.call(answer.querySelectorAll('a')); }
    input.addEventListener('keydown', function (e) {
        if (e.isComposing || e.keyCode === 229) return;
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); return; }
        if (e.key === 'Escape') { input.value = ''; autogrow(); syncGo(); clear(); return; }
        if (e.key === 'ArrowDown' && !answer.hidden) {
            var l = links();
            if (l.length) { e.preventDefault(); l[0].focus(); }
        }
    });
    answer.addEventListener('keydown', function (e) {
        var l = links(), i = l.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowDown' && i < l.length - 1) { e.preventDefault(); l[i + 1].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) l[i - 1].focus(); else input.focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); input.focus(); }
    });

    answer.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a') : null;
        if (!a || !state) return;
        var act = a.getAttribute('data-ha-act');
        var rank = parseInt(a.getAttribute('data-ha-rank') || '0', 10);
        cancelSettle();
        if (rank) {
            var slug = a.getAttribute('data-ha-slug') || '';
            logIntent('pick', { pick: slug, rank: rank });
            try {
                if (window.__ae) window.__ae('search_click', { q: state.q.slice(0, 60), clicked: slug, url: a.getAttribute('href') || '', rank: rank, src: fromChip ? 'home-chip' : 'home' });
            } catch (err) {}
        } else if (act === 'unmet') {
            logIntent('unmet');
            try { if (window.__ae) window.__ae('search_click', { q: state.q.slice(0, 60), clicked: 'request-tool', url: a.getAttribute('href') || '', src: 'home' }); } catch (err) {}
        } else if (act === 'more') {
            logIntent('more');
        }
    });

    // Пример отвечает без ожидания: карточка его инструмента пришла со
    // страницей (data-chips), поиск только дописывает запасные.
    var chips = root.querySelectorAll('[data-ha-chip]');
    for (var c = 0; c < chips.length; c++) {
        chips[c].addEventListener('click', function () {
            var slug = this.getAttribute('data-ha-chip') || '';
            var q = norm(this.textContent);
            input.value = q;
            fromChip = true;
            autogrow();
            syncGo();
            var t = CHIPS[slug];
            if (t) show({ q: q, kind: 'hit', list: [{ t: t, cov: 1, s: 1 }], route: null, dym: '', confident: true, n: 1, top: [slug] });
            query(q);
            feature('home_assistant_chip', slug);
        });
    }

    // Возврат «назад» из инструмента: браузер восстановил текст в поле, а
    // ответа под ним нет — показать его снова.
    syncGo();
    if (norm(input.value).length >= 2) { autogrow(); run(); }
    window.addEventListener('pageshow', function (e) {
        if (e.persisted && norm(input.value).length >= 2 && answer.hidden) run();
    });
})();
